function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  id: "Bounding box",
  x: 0.5,
  y: 0.5,
  width: 24,
  height: 24,
  fill: "currentColor"
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_4344_13698)"
}, /*#__PURE__*/React.createElement("path", {
  id: "icon",
  d: "M11.9846 19.1154H12.9654V17.9423C13.6833 17.8821 14.3712 17.6244 15.0288 17.1692C15.6865 16.7141 16.0154 16.0077 16.0154 15.05C16.0154 14.35 15.8026 13.7532 15.3769 13.2596C14.9513 12.766 14.1385 12.3026 12.9385 11.8692C11.8359 11.4846 11.1314 11.1545 10.825 10.8788C10.5186 10.6032 10.3654 10.2103 10.3654 9.7C10.3654 9.18975 10.5644 8.76475 10.9625 8.425C11.3606 8.08525 11.8898 7.91537 12.55 7.91537C13.0577 7.91537 13.4808 8.03173 13.8192 8.26443C14.1577 8.49713 14.4321 8.79232 14.6423 9.15L15.5115 8.8077C15.2769 8.32693 14.933 7.92437 14.4798 7.6C14.0266 7.27563 13.5385 7.09487 13.0154 7.0577V5.88463H12.0346V7.0577C11.1628 7.20257 10.5032 7.52757 10.0558 8.0327C9.60834 8.53782 9.38463 9.09358 9.38463 9.7C9.38463 10.4192 9.61058 10.9949 10.0625 11.4269C10.5144 11.859 11.2769 12.2692 12.35 12.6577C13.4256 13.0539 14.1484 13.4115 14.5183 13.7308C14.8881 14.05 15.0731 14.4897 15.0731 15.05C15.0731 15.7538 14.8163 16.2606 14.3029 16.5702C13.7894 16.8798 13.2385 17.0346 12.65 17.0346C12.0744 17.0346 11.5548 16.867 11.0914 16.5317C10.6279 16.1965 10.2577 15.7192 9.98077 15.1L9.1 15.4808C9.38462 16.1654 9.76635 16.699 10.2452 17.0817C10.724 17.4644 11.3038 17.7346 11.9846 17.8923V19.1154ZM12.5 21.5C11.2577 21.5 10.0891 21.2631 8.99423 20.7894C7.89936 20.3157 6.94679 19.6737 6.13652 18.8635C5.32627 18.0532 4.68429 17.1006 4.21058 16.0058C3.73686 14.9109 3.5 13.7423 3.5 12.5C3.5 11.2577 3.73686 10.0891 4.21058 8.99422C4.68429 7.89936 5.32627 6.94679 6.13652 6.13652C6.94679 5.32627 7.89936 4.68429 8.99423 4.21057C10.0891 3.73686 11.2577 3.5 12.5 3.5C13.7423 3.5 14.9109 3.73686 16.0058 4.21057C17.1006 4.68429 18.0532 5.32627 18.8635 6.13652C19.6737 6.94679 20.3157 7.89936 20.7894 8.99422C21.2631 10.0891 21.5 11.2577 21.5 12.5C21.5 13.7423 21.2631 14.9109 20.7894 16.0058C20.3157 17.1006 19.6737 18.0532 18.8635 18.8635C18.0532 19.6737 17.1006 20.3157 16.0058 20.7894C14.9109 21.2631 13.7423 21.5 12.5 21.5ZM12.5 20.5C14.7333 20.5 16.625 19.725 18.175 18.175C19.725 16.625 20.5 14.7333 20.5 12.5C20.5 10.2667 19.725 8.375 18.175 6.825C16.625 5.275 14.7333 4.5 12.5 4.5C10.2667 4.5 8.375 5.275 6.825 6.825C5.275 8.375 4.5 10.2667 4.5 12.5C4.5 14.7333 5.275 16.625 6.825 18.175C8.375 19.725 10.2667 20.5 12.5 20.5Z",
  fill: "currentColor"
}));

function SvgIconMoney({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "monetization_on"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4344_13698",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _ref), _ref2));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMoney);
export default __webpack_public_path__ + "static/media/icon-money.a28beb228ddb46b96220475790f0090a.svg";
export { ForwardRef as ReactComponent };